import React from 'react';
import ServiceTech from '../../component/servicetech'
import datanalyticsheader from '../../assets/datanalyticsheader.jpg';
import datanalyticskey1 from '../../assets/datanalytics1.jpg';
import datanalyticskey2 from '../../assets/datanalytics2.jpg';
import datanalyticskey3 from '../../assets/datanalytics3.jpg';
const DataAnalytics = () => {
    const data = {
        "headerimg": datanalyticsheader,
        "key1img": datanalyticskey1,
        "key2img": datanalyticskey2,
        "key3img": datanalyticskey3,
        "maintitle": "Data is the new oil—refine it to fuel your business decisions",
        "mainsub": "Harnessing the Power of Data for Informed Growth",
        "title": "Data Analytics",
        "subtext": "Our data analytics solutions empower your business with actionable insights to make informed decisions. We turn complex data into valuable information that drives growth, improves performance, and identifies opportunities. Whether you're looking to optimize operations or predict market trends, our advanced analytics tools provide real-time data for better strategic planning.",
        "choose1": "We provide data analytics solutions that transform raw data into actionable insights, empowering your business to make informed, data-driven decisions that drive growth and innovation.",
        "choose2": "Our advanced analytics solutions leverage predictive modeling to help you forecast trends and opportunities, enabling proactive strategies that keep you ahead of competitors in the market.",
        "choose3": "We offer real-time analytics tools that allow you to monitor key performance indicators and make timely, data-driven decisions, leading to improved business outcomes and overall success.",
        "key1": "Actionable Insights",
        "key2": "Predictive Analytics",
        "key3": "Data-Driven Decision Making",
        "key4": "Real-Time Analytics",
        "key5": "Enhanced Customer Understanding",
        "text1": "Data analytics transforms raw data into actionable insights, helping businesses make informed decisions that drive growth, improve efficiency, and enhance performance.",
        "text2": "Leverage predictive models to forecast future trends, customer behavior, and market dynamics, enabling businesses to stay ahead of the curve and plan proactively.",
        "text3": "Empower your organization to make objective, data-backed decisions that optimize operations, reduce risks, and uncover new opportunities for growth and innovation.",
        "text4": "Access real-time data to monitor business performance and respond quickly to emerging trends or issues, ensuring agility and responsiveness in fast-paced environments.",
        "text5": "Gain deeper insights into customer behavior, preferences, and needs through advanced analytics, allowing for personalized marketing strategies and improved customer experiences.",
        "text6": "With our expertise in Consultancy, organizations can rethink, re-engineer, and optimize their strategies for enhanced performance and sustainable growth."




    }

    return (



        <>
            <ServiceTech values={data} />
        </>



    )
};

export default DataAnalytics;
